var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5937 10.6466C19.2904 10.9182 18.7998 10.9172 18.4978 10.6445L13.5968 6.21831L13.5968 18.4688L13.5897 18.5634C13.5384 18.9035 13.2141 19.1657 12.8218 19.1657C12.3938 19.1657 12.0468 18.8537 12.0468 18.4688L12.0468 6.21976L7.14598 10.6445L7.05922 10.7122C6.7563 10.9152 6.32572 10.8935 6.05002 10.6466C5.74675 10.375 5.74573 9.93376 6.04775 9.66105L12.2552 4.056C12.3913 3.92486 12.583 3.84101 12.7966 3.83488C13.004 3.82871 13.2136 3.89697 13.3716 4.03967L19.5961 9.66109L19.6709 9.7394C19.8954 10.0126 19.8695 10.3997 19.5937 10.6466Z",
    fill: "#A9A9A9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpButton);
export default __webpack_public_path__ + "static/media/upButton.a1ba93b270602156824a611d6a63dda0.svg";
export { ForwardRef as ReactComponent };